<div class="bannerWrap bg-gradient">
    <h1 class="text-gradient">
        THE BLOG
    </h1>

    <div class="maxContainerWidth">
        <div class="blogsGridWrap flex justify-between">
            <div class="blog">
                <div class="blogImg">
                    <img src="assets/images/blog-listing/blog1.png" alt="">
                </div>
                <div class="blogDate">
                    may 20,2022
                </div>
                <div class="blogTitle text-white">
                    Header
                </div>
                <div class="blogDescription">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                </div>
            </div>
            <div class="blogsRow">
                <div class="blog flex items-center">
                    <div class="img">
                        <img src="assets/images/blog-listing/blog2.png" alt="">
                    </div>
                    <div class="blogDetails">
                        <div class="blogDate text-white">
                            may 20,2022
                        </div>
                        <div class="blogTitle text-white">
                            Header
                        </div>
                        <div class="blogDescription">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                        </div>
                    </div>
                </div>
                <div class="blog flex items-center">
                    <div class="img">
                        <img src="assets/images/blog-listing/blog3.png" alt="">
                    </div>
                    <div class="blogDetails">
                        <div class="blogDate text-white">
                            may 20,2022
                        </div>
                        <div class="blogTitle text-white">
                            Header
                        </div>
                        <div class="blogDescription">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                        </div>
                    </div>
                </div>
                <div class="blog flex items-center">
                    <div class="img">
                        <img src="assets/images/blog-listing/blog4.png" alt="">
                    </div>
                    <div class="blogDetails">
                        <div class="blogDate text-white">
                            may 20,2022
                        </div>
                        <div class="blogTitle text-white">
                            Header
                        </div>
                        <div class="blogDescription">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. 
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>